import {
  WELL_VOLUME_OPTIONS_96,
  WELL_VOLUME_OPTIONS_384,
  PLATE_SIZE_OPTIONS,
  COUNTRY_CODE_JAPAN,
  JAPAN_WELL_VOLUME_OPTIONS_96,
  SYNTHESIS_SCALE_OPTIONS,
  JAPAN_SYNTHESIS_SCALE_OPTIONS,
  SHIPPING_FORMAT_OPTIONS,
  JAPAN_SHIPPING_FORMAT_OPTIONS,
  AMPLISEQ_PLATE_SIZE_OPTIONS,
  PLATE_SIZES,
  SECOND_PRIORITY_COUNTRIES,
  SECOND_PRIORITY_COUNTRY_OPTIONS_96
} from 'src/constants/forms';
import { getCountryCode } from 'src/utils';
import { DnaOligo } from 'src/models';

import messages from './messages';

export const getPlateSizesConfig = (value) => {
  let options = [...PLATE_SIZE_OPTIONS];
  const dnaType = DnaOligo.getDNAType();

  if (value === PLATE_SIZES.SIZE_96 && dnaType) {
    options = AMPLISEQ_PLATE_SIZE_OPTIONS[dnaType];
  }

  return options.map((item) => ({
    ...item,
    disabled: item.value !== value,
    tooltipMessage: item.value !== value ? messages.platesizeTooltip : null,
  }));
};

export const getWellVolumeConfig = (plateSize = PLATE_SIZES.SIZE_96) => {
  let options = WELL_VOLUME_OPTIONS_96;

  if (plateSize === PLATE_SIZES.SIZE_384) {
    options = WELL_VOLUME_OPTIONS_384;
  }

  if (plateSize === PLATE_SIZES.SIZE_96 && getCountryCode() === COUNTRY_CODE_JAPAN) {
    options = JAPAN_WELL_VOLUME_OPTIONS_96;
  }

  if (plateSize === 96 && SECOND_PRIORITY_COUNTRIES.includes(getCountryCode())) {
    options = SECOND_PRIORITY_COUNTRY_OPTIONS_96;
  }

  return options;
};

export const getSynthesisScaleConfig = () => {
  let options = SYNTHESIS_SCALE_OPTIONS;

  if (getCountryCode() === COUNTRY_CODE_JAPAN) {
    options = JAPAN_SYNTHESIS_SCALE_OPTIONS;
  }

  return options;
};

export const getShippingFormatConfig = () => {
  let options = SHIPPING_FORMAT_OPTIONS;

  if (getCountryCode() === COUNTRY_CODE_JAPAN) {
    options = JAPAN_SHIPPING_FORMAT_OPTIONS;
  }

  return options;
};
